import cryptoBrowserify from 'crypto-browserify';
export default cryptoBrowserify;